import React, { ReactNode } from 'react'
import styled from 'styled-components'

type Props = {
  backgroundColor?: string
  padding?: string
  children: ReactNode
  className?: string
}

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-radius: 0;
  max-width: 854px;
  min-height: 400px;
  width: 100%;

  @media (min-width: 768px) {
    border-radius: 1.5rem;
  }
`

export const BackgroundCard: React.FC<Props> = (props) => {
  return (
    <CardWrapper
      style={{
        padding: props.padding ?? '48px',
        backgroundColor: props.backgroundColor,
      }}
      className={props.className ?? ''}
    >
      {props.children}
    </CardWrapper>
  )
}
